import React from 'react'

import { AttachmentsAttribute } from 'features/views/attributes/editable/AttachmentsAttribute'
import { CheckboxAttribute } from 'features/views/attributes/editable/CheckboxAttribute'
import { CurrencyAttribute } from 'features/views/attributes/editable/CurrencyAttribute'
import { DateAttribute } from 'features/views/attributes/editable/DateAttribute'
import { DropdownAttribute } from 'features/views/attributes/editable/DropdownAttribute'
import { InlineEditingAttributeContextProvider } from 'features/views/attributes/editable/InlineEditingAttributeContextProvider'
import { LongTextAttribute } from 'features/views/attributes/editable/LongTextAttribute'
import { NumberAttribute } from 'features/views/attributes/editable/NumberAttribute'
import { PercentageAttribute } from 'features/views/attributes/editable/PercentageAttribute'
import { RecordLinksAttribute } from 'features/views/attributes/editable/RecordLinksAttribute'
import { RichTextAttribute } from 'features/views/attributes/editable/RichTextAttribute'
import { TextAttribute } from 'features/views/attributes/editable/TextAttribute'
import { EditableAttributeProps } from 'features/views/attributes/editable/types'
import { UrlAttribute } from 'features/views/attributes/editable/UrlAttribute'
import { UserAttribute } from 'features/views/attributes/editable/UserAttribute'

type AttributeContextProviderProps = React.ComponentPropsWithoutRef<
    typeof InlineEditingAttributeContextProvider
>

type FieldCollectionAttributeFieldProps = EditableAttributeProps & {
    editingFields: AttributeContextProviderProps['editingFields']
    toggleEditingField: AttributeContextProviderProps['toggleEditingField']
}

export const FieldCollectionAttributeField: React.FC<FieldCollectionAttributeFieldProps> = ({
    editingFields,
    toggleEditingField,
    field,
    isLoading,
    ...props
}) => {
    return (
        <InlineEditingAttributeContextProvider
            editingFields={editingFields}
            toggleEditingField={toggleEditingField}
            field={field}
            isLoading={isLoading}
        >
            <AttributeContent field={field} isLoading={isLoading} {...props} />
        </InlineEditingAttributeContextProvider>
    )
}

const AttributeContent: React.FC<EditableAttributeProps> = (props) => {
    switch (props.field.field.type) {
        case 'string':
            return <TextAttribute {...props} />

        case 'long_text':
            return <LongTextAttribute {...props} />

        case 'document':
            return <RichTextAttribute {...props} />

        case 'url':
            return <UrlAttribute {...props} />

        case 'checkbox':
            return <CheckboxAttribute {...props} />

        case 'number':
            return <NumberAttribute {...props} />

        case 'currency':
            return <CurrencyAttribute {...props} />

        case 'percentage':
            return <PercentageAttribute {...props} />

        case 'date':
        case 'datetime':
            return <DateAttribute {...props} />

        case 'user_ref':
            return <UserAttribute {...props} />

        case 'multi_file':
            return <AttachmentsAttribute {...props} />

        case 'multi_lookup':
        case 'lookup':
            return <RecordLinksAttribute {...props} />

        case 'dropdown':
        case 'multi_select':
            return <DropdownAttribute {...props} />

        default:
            return null
    }
}
